<template>
  <div style="display: inline-block;">
    <span @click="addProduct()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <h3 class="text-center">添加商家</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <el-form-item label="" prop="name">
          <YueDanIpt model="name" :object="form" placeholder="商家名称"></YueDanIpt>
        </el-form-item>
        <el-form-item label="" prop="website">
          <YueDanIpt model="website" :object="form" placeholder="商家链接"></YueDanIpt>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="block" type="primary" @click="submit()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'AddShop',
  components: {
    YueDanIpt: YueDanIpt
  },
  data () {
    return {
      dialogFormVisible: false,
      loading: false,
      errors: null,
      isEmptyErrors: true,
      form: {
        name: '',
        website: ''
      },
      rules: {
        name: [
          { required: true, message: '商家名称是必填项', trigger: 'blur' }
        ],
        website: [
          { required: true, message: '商家链接是必填项', trigger: 'blur'},
          {
            message: '商家链接格式错误',
            trigger: 'blur',
            pattern: /(((^[https|http]?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g}
        ]
      }
    }
  },
  methods: {
    addProduct: function () {
      this.dialogFormVisible = true
    },
    init () {
      this.errors =  null
      this.form = {
        name: '',
        website: ''
      }
      this.isEmptyErrors = true
    },
    submit () {
      this.$refs['form'].validate((valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          api.post(this, {
            path: 'business.php',
            data: this.form,
            loading: 'loading',
            api: 'add'
          }).then((res) => {
            if (res.body.status === 'ok') {
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.init()
              this.dialogFormVisible = false
              this.$emit('success')
            }
          }, err => {

          })
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
span {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/components/AddShop.vue